import React from 'react';
import sanitizeFilename from '../../../../helpers/sanitize-filename';

class PdfForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectFile = this.handleSelectFile.bind(this);
  }
  render() {
    return (
      <div>
        <div className="form-group">
          <label>
            FILE { this.props.pdf.id ? `(${this.props.pdf.id})` : null }
          </label>
          <div>
            <input type="file" name="file" onChange={ this.handleSelectFile } />
          </div>
        </div>
        <br/>
        { this.props.uploading ? 'UPLOADING...' : '' }
      </div>
    );
  }

  handleSelectFile(evt) {
    const htmlFile = evt.currentTarget.files[0];
    const filename = sanitizeFilename(htmlFile.name);
    this.props.onChange({ filename, payload: htmlFile });
  }
}

PdfForm.propTypes = {
  pdf: React.PropTypes.object,
  onChange: React.PropTypes.func,
  uploading: React.PropTypes.bool,
};

export default PdfForm;



// WEBPACK FOOTER //
// ./src/frontend/modules/email/property-data/components/PdfForm.jsx